module.exports = __webpack_public_path__ + "static/media/Picture5.ad2c84ff.jpg";